
import { defineComponent } from "vue";

export default defineComponent({
  name: "merchant-actions-tutorial-modal",
  components: {},
  setup() {
    const url =
      "https://devcrm.chargebacks.online/images/phpRU4FmO20221109091334.png";
    const srcList = [
      "https://devcrm.chargebacks.online/images/phpRU4FmO20221109091334.png",
      "https://devcrm.chargebacks.online/images/php9OQ8kx20221109091058.png",
      "https://devcrm.chargebacks.online/images/phpKqSILo20221109105731.png",
    ];
    return { url, srcList };
  },
});
